module.exports = __webpack_public_path__ + "img/BANNER.44dc0f9d.svg";